import Handler from "../Handler";

class WaitForBBHandler extends Handler {
    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processWaitForBBMessage(receivedData);
    }
}

export default WaitForBBHandler;